import "./Body.css";
import React, { useState } from "react";
import Footer from "./Footer.js";
import About from "./About.js";
// import Founder from "./Founder.js";
import Header from "./Header.js";
import Badges from "./components/Badges.js";
import ConcreteButton from "./components/ConcreteButton.js";
import logo from "../assets/images/logo.png";
import logoLarge from "../assets/images/logoLarge.png";
import ceriseTypography from "../assets/images/ceriseTypography.png";
import darkConcrete from "../assets/images/darkConcrete.jpg";
import dividerLine from "../assets/images/dividerLine.png";
import mainPageAccent from "../assets/images/mainPageAccent.svg";

function Body(props) {
  const [activeTab, setActiveTab] = useState("home");

  return (
    <div class="bodyBlock">
      <Header
        isMobile={props.isMobile}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div style={{ display: "flex" }}>
        <div className="leftBody">
          <img className="logoImage" src={logo} alt="cerise logo - interlocking black C's converging in the center into a round, pink dot"></img>
          <img
            className="ceriseTypography"
            src={ceriseTypography}
            alt="cerise technology"
          ></img>
          <p className="bodyText bodyLargeText"> building technology for a brighter future</p>
          <img className="bodyDividerLine" alt="a cerise ombre line separating paragraphs, starting light pink and ending dark red" src={dividerLine}/>
          <p className="bodyText">
          At Cerise Technology, we develop applications for web, mobile, and desktop. We’re driven by our vision of a smarter, more connected future, with efficiency, inclusivity, and sustainability as some of our core values.
          </p>
          <div className="missionButton">
            <ConcreteButton isSmall={true} text="full mission" href="/mission" />
          </div>
          <p className="bodyText"> </p>
        </div>
        <div className="rightBody">
          <img
            className="darkConcrete"
            src={darkConcrete}
            alt="dark grey wall of concrete"
          ></img>
         <Badges />
          <img className="logoLarge" src={logoLarge} alt="abstract logo"/>
          <img className="mainPageAccent" src={mainPageAccent} alt="4 black circle outlines overlapping in a straight line, each with a smaller, thinner black circle inside, with a straight line running down the center"/>
          <div className="portfolioButton">
            <ConcreteButton
              isSmall={true}
              text="full portfolio"
              href="/portfolio"
            />
          </div>
        </div>
      </div>
      <About />
      {/* <Founder /> */}
      <Footer />
    </div>
  );
}

export default Body;
